import React from 'react'

const ControlButtonClose = ({ onClick }) => {
    return (
        <button onClick={() => onClick()} className="bg-green-400 mx-auto py-2 px-2 sm:px-4 rounded-2xl w-[30%] shadow shadow-xl hover:shadow-2xl duration-300">
            <div className='flex flex-row w-full justify-center relative z-0'>
                <div>CERRAR</div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="w-6 h-6 absolute right-0">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18" />
                </svg>
            </div>
        </button>
    );
}
 
export default ControlButtonClose;